<template>
  <div>
    <DxPopup
      :visible="confirmDeliveryPopup"
      :close-on-outside-click="true"
      :show-close-button="true"
      class="DxPopup"
      width="550"
      height="auto"
      :title-template="'customTitle'"
      container=".dx-viewport"
      @hiding="hide"
    >
      <template #customTitle>
        <div class="custom-popup-title">
          <span class="fa-stack">
            <i
              class="fa-solid fa-circle fa-stack-2x"
              style="
                color: transparent;
                border: 2px solid #fff;
                border-radius: 50%;
              "
            >
            </i>
            <i
              class="fa-solid fa-thumbs-up fa-stack-1x"
              style="transform: rotate(-15deg)"
            >
            </i>
          </span>
        </div>
      </template>
      <div class="popup-content">
        <h2>{{ $t('Thanks') }}</h2>
        <h3 class="popup-title">
          {{ $t('sampleCodeGenerated') }}
        </h3>
        <h2 class="popup-subTitle">
          {{ $t('shippingCode') }} : A-25-00027
        </h2>
        <h3>{{ $t('printCopiesInstruction') }}</h3>
        <div class="popup-actions">
          <f7-button
            class="btn-accept"
            fill
            outline
            type="default"
            @click="confirmAcceptance"
          >
            {{ $t('cookiesBanner.accept') }}
          </f7-button>
        </div>
      </div>
    </DxPopup>
  </div>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';
import { mapActions, mapState } from 'vuex';
import { NOTIFY_TIME_LONG } from '@/js/constants';

export default {
  components: {
    DxPopup,
  },
  data() {
    return {
      RequestCode: '',
    };
  },
  computed: {
    ...mapState('samplesRegisterModule', ['confirmDeliveryPopup']),
  },
  methods: {
    hide() {
      this.setConfirmDeliveryPopup(false);
    },
    async confirmAcceptance() {
      try {
        this.$f7.preloader.show();
        this.hide();
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
        this.hide();
      }
    },
    ...mapActions('samplesRegisterModule', [
      'setConfirmDeliveryPopup',
    ]),
  },
};
</script>

<style scoped>
.custom-popup-title {
  background: linear-gradient(135deg, #04509F, #00346A);
  color: white;
  padding: 10px;
  font-size: 1.4rem;
  font-weight: bold;
  text-align: center;
  border-radius: 10px 10px 0 0;
}
.popup-content {
  padding: 25px;
  text-align: center;
  font-family: 'Arial', sans-serif;
}
.popup-title {
  font-size: 1.4rem;
  margin-bottom: 15px;
  font-weight: bold;
}
.popup-subTitle {
  font-size: 1.2rem;
  margin-bottom: 20px;
  color: #06a106;
  font-weight: bold;
}
.popup-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.btn-accept {
  color: white;
  border-radius: 10px;
  font-size: 1rem;
  width: 100%;
}
.btn-accept:hover {
  background: #00346A;
  transform: scale(1.05);
}
</style>
